/* unplugin-vue-components disabled */import { render } from "./w-text-input.vue?vue&type=template&id=de40959c&scoped=true&ts=true"
import script from "./w-text-input.vue?vue&type=script&lang=ts"
export * from "./w-text-input.vue?vue&type=script&lang=ts"

import "./w-text-input.vue?vue&type=style&index=0&id=de40959c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de40959c"]])

export default __exports__